import { useState, useEffect } from "react";
import "./index.scss";

const SearchBar = ({
  searchOptions,
  onSearch,
  placeholder,
  showSearchButton = true,
  initialValue = "",
}) => {
  const [selectedOption, setSelectedOption] = useState(searchOptions[0].value);
  const [searchValue, setSearchValue] = useState(initialValue);

  // Sync with external initialValue changes (like when filters are cleared)
  useEffect(() => {
    setSearchValue(initialValue);
  }, [initialValue]);

  const handleSearch = () => {
    if (searchValue.trim()) {
      onSearch(selectedOption, searchValue.trim());
    } else {
      // If search is empty, show all results
      onSearch(selectedOption, "");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const getCurrentPlaceholder = () => {
    const option = searchOptions.find((opt) => opt.value === selectedOption);
    return option ? option.placeholder : placeholder || "Search...";
  };

  // Auto-search as user types (debounced)
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    // Auto-search with debouncing
    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      onSearch(selectedOption, value.trim());
    }, 300);
  };

  return (
    <div className="search-bar">
      <div className="search-bar__container">
        {/* Hide dropdown if only one search option */}
        {searchOptions.length > 1 && (
          <select
            className="search-bar__select"
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            {searchOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}

        <input
          type="text"
          className={`search-bar__input ${
            searchOptions.length === 1 ? "search-bar__input--full-width" : ""
          }`}
          placeholder={getCurrentPlaceholder()}
          value={searchValue}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />

        {showSearchButton && (
          <button className="search-bar__button" onClick={handleSearch}>
            🔍
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
